/**
 * Project : workspace
 * File    : BottomNavigationBar.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation.business.botomBar

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.wrapContentSize
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Chat
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.ManageAccounts
import androidx.compose.material3.Button
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.NavigationBar
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.navigation.NavController
import navigation.base.tab.NavigationItem
import navigation.route.business.BusinessNavRoute
import theme.ThemeColor

@Composable
/**
 * Executes the bottom navigation bar operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
fun BottomNavigationBar(
    navController: NavController?,
    start: String = BusinessNavRoute.HOME,
) {
    val selectedNavigationIndex = rememberSaveable {
        mutableIntStateOf(0)
    }
    var startRoute = ""
    if (start.isEmpty()) {
        startRoute = BusinessNavRoute.HOME
    } else {
        startRoute = start
    }
    val navigationItems = listOf(
        NavigationItem(
            title = "Homes",
            icon = Icons.Default.Home,
            route = startRoute
        ),
        NavigationItem(
            title = "Chat",
            icon = Icons.Default.Chat,
            route = BusinessNavRoute.CONVERSATION
        ),
        NavigationItem(
            title = "Account",
            icon = Icons.Default.ManageAccounts,
            route = BusinessNavRoute.ACCOUNT
        ),
    )

    NavigationBar(
        containerColor = ThemeColor.shared().PrimaryColor
    ) {
        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceEvenly) {
            navigationItems.forEachIndexed { index, item ->
                var color = ThemeColor.shared().subTitleColor
                if(index == selectedNavigationIndex.intValue){
                    color = MaterialTheme.colorScheme.surface
                }
                Button(
                    onClick = {
                        selectedNavigationIndex.intValue = index
                        navController?.navigate(item.route)
                    },
                    modifier = Modifier.wrapContentSize(),

                    ) {
                    Column (modifier = Modifier.wrapContentSize(), horizontalAlignment = Alignment.CenterHorizontally){
                        Icon(imageVector = item.icon, contentDescription = item.title, tint = color)
                        Text(item.title, color = color)
                    }
                }
            }
        }
    }
}